import React from 'react';
import { GameInventory } from '../Game_Inventory';

function InventoryPanelComponent({
  player,
  draggedItem,
  canUseGroundLoot,
  canLearnRecipes = false,
  inventoryActionsDisabled = false,
  inventoryActionsDisabledReason = '',
  onDragEnd,
  onDragStart,
  onDrop,
  onLearnRecipe,
  onBeltTransfer,
  onRequestDrop,
  onUseItem,
  knownRecipeIds = [],
}) {
  return (
    <div className="inventory-panel">
      <GameInventory
        userInventory={player?.inventory}
        userEquipment={player?.equipment}
        canUseGroundLoot={canUseGroundLoot}
        canLearnRecipes={canLearnRecipes}
        inventoryActionsDisabled={inventoryActionsDisabled}
        inventoryActionsDisabledReason={inventoryActionsDisabledReason}
        onDragEnd={onDragEnd}
        onDragStart={onDragStart}
        onDrop={onDrop}
        onLearnRecipe={onLearnRecipe}
        onBeltTransfer={onBeltTransfer}
        onRequestDrop={onRequestDrop}
        onUseItem={onUseItem}
        knownRecipeIds={knownRecipeIds}
        draggedItem={draggedItem}
        quickBelt={player?.quickBelt || []}
        quickBeltCapacity={player?.quickBeltCapacity || 1}
      />
    </div>
  );
}

const InventoryPanel = React.memo(InventoryPanelComponent);

export default InventoryPanel;
